import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { catchError, of, tap } from 'rxjs';
import { EulaPost } from 'src/app/interfaces/termsAndConditions';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SessionTimerService } from 'src/app/services/session-timer.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-termsandconditions',
  templateUrl: './termsandconditions.component.html',
  styleUrls: ['./termsandconditions.component.scss'],
  standalone: false
})
export class TermsandconditionsComponent {
  savingStatus?: string = '';
  userProfileLoaded: boolean = false;
  submitInitials: string = '';
  agreeInitials!: FormGroup;
  initialsString: string = '';
  didAttest: boolean = false;
  displayAttestationModal: boolean = false;
  username?: string;
  userProfile?: UserProfile;
  displayLanguageChangeModal: boolean = false;
  displayWarningDialog: boolean = false;
  didAgree: boolean = false;
  shouldSendFormViaEmail: boolean = false;
  submitted: boolean = false;
  ShowLanguageChangeDialogThisManyTimes: number = 10;

  @ViewChild('AttestationModal')
  attestationModal!: TemplateRef<any>;

  @ViewChild('LanguageChangeModal')
  languageChangeModal!: TemplateRef<any>;

  @ViewChild('WarningDialog')
  warningDialog!: TemplateRef<any>;


  constructor(
    public generalService: GeneralService,
    public authenticationService: AuthenticationService,
    public sessionTimerService: SessionTimerService,
    public userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private cookieService: CookieService) { }

  ngOnInit(): void {
    this.username = this.authenticationService.getUserName() || undefined;
    if (!this.username || this.username === '') {
      this.authenticationService.logout();
    }

    this.agreeInitials = new FormGroup({
      initials: new FormControl(this.initialsString, [
        Validators.required,
        Validators.maxLength(3),
        Validators.minLength(2),
        Validators.pattern(/^([a-zA-Z]*)$/)
      ])
    });

    this.authenticationService.getRoles();
    if (this.authenticationService.getRoles().includes('csr_user')) {
      this.authenticationService.setHasAgreedToTerms(true);
      if (environment &&  (environment.production === undefined || environment.production === false)) {
        // we need to do this in anything that is not prod. because the csr and user site are not on the same domain
        const token = this.authenticationService.getUser();
        const fiveMinutesFromNow = new Date();
        //this will set the cookie so the uat csr land can pick it up
        fiveMinutesFromNow.setTime(fiveMinutesFromNow.getTime() + (5 * 60 * 1000)); // 5 minutes in milliseconds
        this.cookieService.set('userJwtCsr', JSON.stringify(token), fiveMinutesFromNow, '/', "." + window.location.hostname, true, "Lax");
      }
      const redirectUrl = `${environment.APP_PSP_NEXT_URL}csr/customers`;
      window.location.href = redirectUrl;
    } else {
      this.getUserProfile();
    }

  }

  get initials() { return this.agreeInitials!.get('initials'); }

  getUserProfile() {
    if (this.username) {
      this.userService.getUserProfile(this.username).pipe(
        tap((userProfile: any) => {
          if (userProfile) {
            this.userProfile = userProfile;
            this.authenticationService.setUserProfile(userProfile);
            this.generalService._Session_custID = (userProfile as UserProfile).customerId;
            this.userProfileLoaded = true;
            this.sessionTimerService.setTimeout();
          } else {
            this.sessionTimerService.clear();
            this.authenticationService.logout();
          }
        }),
        catchError((error: any) => {
          console.error(`Error fetching userProfile ${error}`);
          this.authenticationService.logout();
          return of(null);
        })
      ).subscribe();
    }
  }

  submitEula() {
    this.modalService.dismissAll();
    this.displayAttestationModal = false;
    this.displayLanguageChangeModal = false;
    this.displayWarningDialog = false;
    this.savingStatus = "Saving response";

    //lets add this on the click to aggree or disagree. 
    // sense it seems that after this click they get into the bad loop.
    this.cookieService.delete('userJwt');
    const paths = ['','/', '/psp', '/psp/'];
    const domains = [window.location.hostname, `.${window.location.hostname}`, ''];
            
    paths.forEach(path => {
          domains.forEach(domain => {
              document.cookie = `userJwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain};`;
          });
    });
    //I know this is not what the log is for. but this will give us some debugging on we may be able to use
    //Please remove later
    const jwtCookie = this.cookieService.get('userJwt');
    const username = this.username || '';
    this.generalService.logActivity('terms_conditions::view', username, null, [{name: 'jwtCookie', value: jwtCookie}]);

    /* create disclaimer response */
    const eulaData: EulaPost = {
      username: '',
      firstName: '',
      lastName: '',
      initials: '',
      customerId: '',
      primaryContactEmail: '',
      didAgree: this.didAgree,
      didAttest: this.didAttest,
      previouslyAttested: this.hasPreviouslyAttested(),
      emailAddress: '',
      sendEmail: this.shouldSendFormViaEmail,
      clientIPAddress: "",
      isDriver: this.isDriver()
    };
    if (this.username) eulaData.username = this.username;
    if (this.userProfile && this.userProfile.firstName) eulaData.firstName = this.userProfile!.firstName;
    if (this.userProfile && this.userProfile.lastName) eulaData.lastName = this.userProfile!.lastName;
    if (this.initials) eulaData.initials = this.initials!.value;
    if (this.submitInitials) eulaData.initials = this.submitInitials.toUpperCase();
    if (this.userProfile && this.userProfile.customerId) eulaData.customerId = this.userProfile!.customerId;
    if (this.userProfile && this.userProfile.primaryContactEmail) eulaData.primaryContactEmail = this.userProfile!.primaryContactEmail;
    if (this.userProfile && this.userProfile.userData && this.userProfile.userData.email) eulaData.emailAddress = this.userProfile!.userData!.email;

    // get user IP address then call submitEula, 
    // then redirect to proper dashboard, 
    // or home page if error.

     

    //call API to submit the t&c response
    this.userService.submitEula(eulaData).subscribe((resp: any) => {
      // if they did not agree to the terms and conditions, log them out.
      // t&c response submitted
      this.savingStatus = '';
      if (!eulaData.didAgree) {
        this.generalService.logActivity('terms_conditions::disagree', this.username!);
        this.authenticationService.logout();
      } else {
        this.authenticationService.setHasAgreedToTerms(true);
        const accountType = this.authenticationService.getAccountType();
        if (accountType === 'mah' || accountType === 'tpip') {
          // route to mah dashboard
          this.generalService.logActivity('terms_conditions::agree', this.username!, null, [{ name: 'accountType', value: accountType }]);
          this.router.navigate(['/dashboard']);
        } else if (accountType === 'oa') {
          // route to driver dashboard
          this.generalService.logActivity('terms_conditions::agree', this.username!, null, [{ name: 'accountType', value: accountType }]);
          this.router.navigate(['/driverDashboard']);
        } else {
          this.generalService.logActivity('terms_conditions::agree', this.username!, null, [{ name: 'accountType', value: accountType }]);
          this.authenticationService.logout();
        }
      }
    }
    );
  }

  onBtnAgreeClick() {
    this.submitted = true;
    this.didAgree = true;

    if (this.isAttestationModalNeeded()) {
      this.showAttestationDialog();
    } else if (this.isLanguageChangeModalNeeded() && !this.isDriver()) {
      this.showLanguageChangeDialog();
    } else {
      this.submitEula();
    }
  }

  onBtnDisagreeClick() {
    this.submitted = true;
    this.submitInitials = '***';
    this.didAgree = false;
    this.didAttest = false;
    this.submitEula();
  }

  isLanguageChangeModalNeeded(): boolean {
    if (this.userProfile && this.userProfile.numberOfTimesLoggedIn) {
      if ((this.userProfile.numberOfTimesLoggedIn < this.ShowLanguageChangeDialogThisManyTimes)
        && (this.userProfile.numberOfTimesLoggedIn >= 0)
        && !this.isDriver()) {
        // numberOfTimesLoggedIn is less than 10, so return true
        return true;
      }
      else {
        // numberOfTimesLoggedIn is greater than 10, so return false
        return false;
      }
    }
    return true;
  }

  isAttestationModalNeeded(): boolean {
    this.userProfile = this.userProfile;

    if (this.isDriver()) {
      return false;
    }

    if ((this.userProfile && this.userProfile!.customer && !this.userProfile!.customer!.auditLanguageAttested)
      || (this.userProfile && this.userProfile!.customer && this.userProfile!.customer!.auditLanguageAttested == null)) {
      return true;
    }

    return false;
  }

  showAttestationDialog() {
    this.modalService.open(this.attestationModal, { ariaLabelledBy: 'attestationModalTitle' });
  }

  closeResult: string | undefined;
  open(content: TemplateRef<any>) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  showLanguageChangeDialog() {
    this.modalService.open(this.languageChangeModal, { ariaLabelledBy: 'languageChangeModalTitle' });
  }

  hasPreviouslyAttested(): boolean {
    return this.userProfile?.customer?.auditLanguageAttested ?? false;
  }

  isDriver(): boolean {
    return this.userProfile?.userData?.roles.includes('driver') ?? false;
  }

  updateUrl(url: string) {
    url = url.replace(`##docBaseUrl##`, `${environment.APP_PSP_DOC_BASE_URL}`)
      .replace(`##baseUrl##`, `${environment.APP_PSP_BASE_URL}`);
    return url;
  }

  agreeToAttestation() {
    this.didAttest = true;
    this.displayAttestationModal = false;
    if (this.isLanguageChangeModalNeeded()) {
      this.showLanguageChangeDialog();
    } else {
      this.submitEula();
    }
  }

  disagreeToAttestation() {
    this.modalService.dismissAll();
    this.modalService.open(this.warningDialog, { ariaLabelledBy: 'warningDialogTitle' });
  }

  closeWarningDialog() {
    this.modalService.dismissAll();
    this.didAttest = false;
    this.displayAttestationModal = false;
    this.displayWarningDialog = false;
    if (this.isLanguageChangeModalNeeded()) {
      this.showLanguageChangeDialog();
    } else {
      this.submitEula();
    }
  }

}
